"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createRouteRequest = exports.replaceUrlParams = void 0;
const tslib_1 = require("tslib");
const axios_1 = tslib_1.__importDefault(require("axios"));
const url_join_ts_1 = require("url-join-ts");
const deepmerge_1 = tslib_1.__importDefault(require("deepmerge"));
/**
 * e.g.
 *
 * params = {a: 1, b: 2}
 * path = "/something/:a/:b"
 * return value would be "/something/1/2"
 *
 * @param path
 * @param params
 */
const replaceUrlParams = (path, params) => {
    if (params) {
        for (const [key, value] of Object.entries(params)) {
            const pattern = new RegExp(`(:${key})(/|$)`);
            path = path.replace(pattern, `${value}$2`);
        }
    }
    return path;
};
exports.replaceUrlParams = replaceUrlParams;
const getRequestOpts = (defaultReqOpt, reqOptions) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    const mergeOptions = {
        arrayMerge: (destinationArray, sourceArray) => sourceArray,
    };
    return deepmerge_1.default(defaultReqOpt, reqOptions, mergeOptions);
});
const callRoute = (apiClient, route, reqOptions) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const defaultReqOpt = yield apiClient.getDefaultReqOptions();
    const { params, query, body, headers } = yield getRequestOpts(defaultReqOpt, reqOptions);
    const { method } = route;
    // Build the url
    const routePath = exports.replaceUrlParams(route.path, params);
    const url = url_join_ts_1.urlJoin(apiClient.getBaseUrl(), routePath);
    // Make the request
    const defaultAxiosConfig = (_a = defaultReqOpt.axiosConfig) !== null && _a !== void 0 ? _a : {};
    const config = Object.assign(Object.assign(Object.assign({ validateStatus: (status) => status >= 200 && status < 300 }, defaultAxiosConfig), { method,
        url, 
        // Just in case this has slipped in as part of the default axios config
        baseURL: undefined, params: query, data: body, headers }), (reqOptions.axiosConfig || {}));
    return axios_1.default.request(config);
});
const createRouteRequest = (apiClient, route) => {
    return (options) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        return callRoute(apiClient, route, options);
    });
};
exports.createRouteRequest = createRouteRequest;
//# sourceMappingURL=request.js.map